class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const facetDrawer = document.getElementById('FacetDrawer');
    const countContainer = document.getElementById('ProductCount');
    const countContainerMobile = document.getElementById('ProductCountMobile');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }   
    if (countContainerMobile){
      countContainerMobile.classList.add('loading');
    } 
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }
    if (facetDrawer){
      facetDrawer.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    
    document.dispatchEvent(new CustomEvent('collection:reloaded'));
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    
    const layoutSwitcher = document.querySelector('#FacetSortFiltersForm layout-switcher');
    if (layoutSwitcher) layoutSwitcher.onButtonClick(layoutSwitcher.querySelector('.list-view__item--active'));
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerMobile = document.getElementById('ProductCountMobile');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerMobile) {
      containerMobile.innerHTML = count;
      containerMobile.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetSortFiltersForm .js-filter, #FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => { 
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false; 
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    const facetDrawer = document.getElementById('FacetDrawer');
    if (facetDrawer) {
      facetDrawer.classList.remove('loading');
    }

    // Re-apply persisted gender tab state after filters are re-rendered
    try { setTimeout(initGenderSizeFiltersState, 0); } catch (e) {}
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.facets__open', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('facet-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData);
  }

  mergeSearchParams(form, searchParams) {
    const params = this.createSearchParams(form);
    params.forEach((value, key) => {
      searchParams.append(key, value);
    });
    return searchParams;
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const currentForm = event.target.closest('form');
    if (currentForm.id === 'FacetFiltersFormMobile') {
      const searchParams = this.createSearchParams(currentForm);
      this.onSubmitForm(searchParams.toString(), event);
    }
    else {
      let searchParams = new URLSearchParams();

      if (currentForm.id === 'FacetSortFiltersForm' && currentForm.dataset.filterType === 'drawer') {
        const mobileForm = document.getElementById('FacetFiltersFormMobile');
        searchParams = this.mergeSearchParams(mobileForm, searchParams);
        searchParams.delete('sort_by');
      }
  
      const sortFilterForms = document.querySelectorAll('facet-filters-form form');
      sortFilterForms.forEach((form) => {
        if (form.id === 'FacetFiltersForm' || form.id === 'FacetSortFiltersForm') {
          searchParams = this.mergeSearchParams(form, searchParams);
        }
      });

      this.onSubmitForm(searchParams.toString(), event);
    }
    /*
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
    */
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.renderPage(new URL(event.currentTarget.href).searchParams.toString());
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}
customElements.define('facet-remove', FacetRemove);

// Size Grouping Functionality - Handle master checkbox clicks
function handleGroupedSizeSelection(checkbox) {
  // Handle master checkboxes that control multiple variants
  if (checkbox.classList.contains('size-group-master')) {
    const sizeValue = checkbox.getAttribute('data-size-value');
    const gender = checkbox.getAttribute('data-gender');
    const filterContainer = checkbox.closest('.size-filter-with-gender');
    
    if (!filterContainer || !sizeValue || !gender) return;
    
    console.log(`✓ Master ${gender} size ${sizeValue} clicked (${checkbox.checked})`);
    
    // Persist the selected gender for this filter (stabilize tab on reload)
    try {
      const filterIndex = filterContainer?.dataset?.index || 'size';
      sessionStorage.setItem(`genderTab_index_${filterIndex}`, gender);
    } catch (e) {}
    // Force UI to reflect the chosen gender immediately
    applyGenderUIState(filterContainer, gender);

    // Find all variant checkboxes in the same filter container
    const variantCheckboxes = filterContainer.querySelectorAll('.size-variant-checkbox');
    let toggledCount = 0;
    
    // Toggle matching variants
    variantCheckboxes.forEach(variantCheckbox => {
      const menSize = variantCheckbox.getAttribute('data-men-size');
      const womenSize = variantCheckbox.getAttribute('data-women-size');
      const youthSize = variantCheckbox.getAttribute('data-youth-size');
      
      let shouldToggle = false;
      if (gender === 'men' && menSize === sizeValue) {
        shouldToggle = true;
      } else if (gender === 'women' && womenSize === sizeValue) {
        shouldToggle = true;
      } else if (gender === 'youth' && youthSize === sizeValue) {
        shouldToggle = true;
      }
      
      if (shouldToggle) {
        variantCheckbox.checked = checkbox.checked;
        toggledCount++;
        variantCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    
    console.log(`  → Toggled ${toggledCount} variants`);
    
    // If no variants were affected, revert the master checkbox and do NOT submit
    if (toggledCount === 0) {
      console.warn('No matching variants found for this master size; reverting checkbox and skipping submit');
      checkbox.checked = !checkbox.checked;
      return;
    }
    
    // Trigger AJAX form submission for instant filtering
    const form = checkbox.closest('form');
    if (form) {
      // Small delay to ensure all variant checkboxes are updated
      setTimeout(() => {
        console.log('Triggering AJAX filter update');
        
        // Trigger the form's input event to activate existing AJAX logic
        const inputEvent = new Event('input', { bubbles: true });
        form.dispatchEvent(inputEvent);
      }, 100);
    }
    
    return;
  }
  
  // Handle regular size checkboxes (for backward compatibility)
  if (!checkbox.hasAttribute('data-size-value')) return;
  
  const sizeValue = checkbox.getAttribute('data-size-value');
  const filterContainer = checkbox.closest('.size-filter-with-gender');
  if (!filterContainer) return;
  
  const currentGender = filterContainer.querySelector('.size-gender-tab.active')?.getAttribute('data-gender');
  if (!currentGender) return;
  
  // Persist the currently active gender for this filter (stabilize tab on reload)
  try {
    const filterIndex = filterContainer?.dataset?.index || 'size';
    sessionStorage.setItem(`genderTab_index_${filterIndex}`, currentGender);
  } catch (e) {}
  // Ensure UI stays on the currently active gender
  applyGenderUIState(filterContainer, currentGender);
  
  // Find all checkboxes in the same gender tab that represent the same size
  const genderList = filterContainer.querySelector(`.size-list--${currentGender}`);
  const allSizeCheckboxes = genderList.querySelectorAll('input[type="checkbox"][data-size-value]');
  
  // Find all checkboxes that represent the same size value
  allSizeCheckboxes.forEach(otherCheckbox => {
    const otherSizeValue = otherCheckbox.getAttribute('data-size-value');
    
    // If they represent the same size, sync their state
    if (sizeValue === otherSizeValue && otherCheckbox !== checkbox) {
      otherCheckbox.checked = checkbox.checked;
      
      // Trigger change event on the synced checkbox to ensure form submission works
      otherCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}

// Gender Size Filter Functionality - Using Event Delegation
document.addEventListener('DOMContentLoaded', function() {
  // Handle size checkbox changes to group related sizes
  document.addEventListener('change', function(e) {
    if (e.target.type === 'checkbox' && e.target.closest('.size-filter-with-gender')) {
      console.log('Checkbox change detected:', e.target.id, 'checked:', e.target.checked, 'classes:', e.target.className);
      
      // Handle master checkboxes immediately
      if (e.target.classList.contains('size-group-master')) {
        console.log('Master checkbox detected, calling handleGroupedSizeSelection');
        handleGroupedSizeSelection(e.target);
      } else {
        console.log('Regular checkbox detected, calling handleGroupedSizeSelection with delay');
        // Small delay for regular checkboxes
        setTimeout(() => handleGroupedSizeSelection(e.target), 10);
      }
    }
  });
  // Use event delegation to handle clicks on gender tabs
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('size-gender-tab')) {
      const gender = e.target.getAttribute('data-gender');
      const filterContainer = e.target.closest('.size-filter-with-gender');
      
      if (!filterContainer) return;
      
      // Store the selected gender in session storage using stable index-based key
      const filterIndex = filterContainer?.dataset?.index || 'size';
      const storageKey = `genderTab_index_${filterIndex}`;
      sessionStorage.setItem(storageKey, gender);
      
      // Update active tab
      filterContainer.querySelectorAll('.size-gender-tab').forEach(t => t.classList.remove('active'));
      e.target.classList.add('active');
      
      // Update active size list
      filterContainer.querySelectorAll('.size-list').forEach(list => list.classList.remove('active'));
      const targetList = filterContainer.querySelector(`.size-list--${gender}`);
      if (targetList) {
        targetList.classList.add('active');
      }
    }
  });
  
  // Append size_tab param to product links based on active gender tab (PLP)
  document.addEventListener('click', function(e) {
    const anchor = e.target && e.target.closest && e.target.closest('a[href]');
    if (!anchor) return;
    try {
      const url = new URL(anchor.getAttribute('href'), window.location.origin);
      // Only modify links that go to a product page
      if (!/\/products\//.test(url.pathname)) return;
      // Detect active gender tab from any size filter on the page
      const filter = document.querySelector('.size-filter-with-gender');
      const activeGender = filter?.querySelector('.size-gender-tab.active')?.getAttribute('data-gender');
      if (activeGender === 'women' || activeGender === 'youth') {
        url.searchParams.set('size_tab', activeGender);
        anchor.setAttribute('href', url.toString());
      }
    } catch (err) {}
  }, true);
  
  // Initialize gender tabs state
  initGenderSizeFiltersState();
  
  // Re-initialize state after collection is reloaded (when filters are cleared/applied)
  document.addEventListener('collection:reloaded', function() {
    // Just re-apply persisted state; do not clear stored tab preference implicitly
    setTimeout(initGenderSizeFiltersState, 100);
  });
  
  // Re-initialize state after any form change in facets
  document.addEventListener('change', function(e) {
    if (e.target.closest('facet-filters-form') || e.target.closest('.mobile-facets')) {
      // Small delay to let the AJAX content load
      setTimeout(initGenderSizeFiltersState, 500);
    }
  });

  // Observe DOM changes to facets to re-apply persisted gender state after AJAX fragment swaps
  try {
    const targetNodes = [
      document.getElementById('FacetFiltersForm'),
      document.getElementById('FacetFiltersFormMobile'),
      document.getElementById('FacetSortFiltersForm')
    ].filter(Boolean);

    const observer = new MutationObserver((mutations) => {
      let shouldInit = false;
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          // If any size filter container was added/changed
          const addedHasSizeFilter = Array.from(mutation.addedNodes || []).some(n =>
            n.nodeType === 1 && (n.matches?.('.size-filter-with-gender') || n.querySelector?.('.size-filter-with-gender'))
          );
          if (addedHasSizeFilter) {
            shouldInit = true;
            break;
          }
        }
      }
      if (shouldInit) {
        // Delay a tick to ensure layout has applied
        setTimeout(initGenderSizeFiltersState, 50);
      }
    });

    targetNodes.forEach(node => observer.observe(node, { childList: true, subtree: true }));
  } catch (e) {}
});

// Utility: apply tab and list active classes for a given gender within a filter container
function applyGenderUIState(filterContainer, gender) {
  try {
    if (!filterContainer || !gender) return;
    const tabs = filterContainer.querySelectorAll('.size-gender-tab');
    const lists = filterContainer.querySelectorAll('.size-list');
    tabs.forEach(t => t.classList.remove('active'));
    lists.forEach(l => l.classList.remove('active'));
    const targetTab = filterContainer.querySelector(`.size-gender-tab[data-gender="${gender}"]`);
    const targetList = filterContainer.querySelector(`.size-list--${gender}`);
    if (targetTab) targetTab.classList.add('active');
    if (targetList) targetList.classList.add('active');
  } catch (e) {}
}

function initGenderSizeFiltersState() {
  document.querySelectorAll('.size-filter-with-gender').forEach(filter => {
    const menTab = filter.querySelector('[data-gender="men"]');
    const womenTab = filter.querySelector('[data-gender="women"]');
    const youthTab = filter.querySelector('[data-gender="youth"]');
    const menList = filter.querySelector('.size-list--men');
    const womenList = filter.querySelector('.size-list--women');
    const youthList = filter.querySelector('.size-list--youth');
    
    if (menTab && womenTab && menList && womenList) {
      const filterIndex = filter?.dataset?.index || 'size';
      const storageKey = `genderTab_index_${filterIndex}`;
      const storedGender = sessionStorage.getItem(storageKey);
      
      const menChecked = menList.querySelector('input[type="checkbox"]:checked');
      const womenChecked = womenList.querySelector('input[type="checkbox"]:checked');
      const youthChecked = youthList?.querySelector('input[type="checkbox"]:checked');
      
      let activeGender = 'men';
      
      if (storedGender === 'youth' && youthTab) {
        activeGender = 'youth';
      } else if (storedGender === 'women') {
        activeGender = 'women';
      } else if (storedGender === 'men') {
        activeGender = 'men';
      } else if (youthChecked && !menChecked && !womenChecked) {
        activeGender = 'youth';
      } else if (womenChecked && !menChecked && !youthChecked) {
        activeGender = 'women';
      } else if (menChecked && !womenChecked && !youthChecked) {
        activeGender = 'men';
      } else {
        activeGender = 'men';
      }
      
      applyGenderUIState(filter, activeGender);
    }
  });
}



class PriceRange extends HTMLElement {
	constructor() {
    super();

    this.min = Number(this.dataset.min);
		this.max = Number(this.dataset.max);
    this.track = this.querySelector(".price-range__track");
		this.handles = [...this.querySelectorAll(".price-range__thumbs")];
		this.startPos = 0;
		this.activeHandle;
		
		this.handles.forEach(handle => {
			handle.addEventListener("mousedown", this.startMove.bind(this));
		})
		
		window.addEventListener("mouseup", this.stopMove.bind(this));

    this.querySelectorAll('input').forEach(
      element => element.addEventListener('change', this.onRangeChange.bind(this))
    );
	}

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }
	
	startMove(e) {
		this.startPos = e.offsetX;
		this.activeHandle = e.target;
		this.moveListener = this.move.bind(this);
		window.addEventListener("mousemove", this.moveListener);
	}
	
	move(e) {
		const isLower = this.activeHandle.classList.contains("is-lower");
		const property = isLower ? "--progress-lower" : "--progress-upper";
		const parentRect = this.track.getBoundingClientRect();
		const handleRect = this.activeHandle.getBoundingClientRect();
		let newX = e.clientX - parentRect.x - this.startPos;
		
    if (isLower) {
			const otherX = parseInt(this.style.getPropertyValue("--progress-upper"));
      const percentageX = otherX * parentRect.width / 100;
			newX = Math.min(newX, percentageX - handleRect.width);
			newX = Math.max(newX, 0 - handleRect.width/2);
		}
    else {
			const otherX = parseInt(this.style.getPropertyValue("--progress-lower"));
      const percentageX = otherX * parentRect.width / 100;
			newX = Math.max(newX, percentageX);
			newX = Math.min(newX, parentRect.width - handleRect.width/2);
		}

    const percentage = (newX + handleRect.width/2) / parentRect.width;
    const valuenow = this.calcHandleValue(percentage);
    this.style.setProperty(property, percentage * 100 + "%");
		this.activeHandle.ariaValueNow = valuenow;

    const output = this.activeHandle.nextElementSibling;
    const text = output.querySelector('.price-range__output-text');
    text.innerHTML = valuenow;

    const inputs = this.querySelectorAll('input');
    const input = isLower ? inputs[0] : inputs[1];
    input.value = valuenow;
    
    this.adjustToValidValues(input);
    this.setMinAndMaxValues();
	}
	
	calcHandleValue(percentage) {
		return Math.round(percentage * (this.max - this.min) + this.min);
	}
	
	stopMove() {
		window.removeEventListener("mousemove", this.moveListener);
    const form = this.closest('form');
    
    if (this.activeHandle && form) form.dispatchEvent(new Event('input'));
	}

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('price-range', PriceRange);

class PriceRangeCheckboxes extends HTMLElement {
  constructor() {
    super();
    this.radios = this.querySelectorAll('input[type="checkbox"]');
    this.hiddenInputs = this.querySelectorAll('input[type="hidden"]');
    this.minInput = this.hiddenInputs[0];
    this.maxInput = this.hiddenInputs[1];

    this.radios.forEach(radio => {
      radio.addEventListener('click', this.onRadioClick.bind(this));
    });
  }

  onRadioClick(event) {
    const radio = event.currentTarget;
    const wasChecked = radio.dataset.wasChecked === 'true';

    this.radios.forEach(r => {
      r.checked = false;
      r.dataset.wasChecked = 'false';
    });

    if (wasChecked) {
      radio.checked = false;
      radio.dataset.wasChecked = 'false';
      this.minInput.value = '';
      this.maxInput.value = '';
    } else {
      radio.checked = true;
      radio.dataset.wasChecked = 'true';
      this.minInput.value = radio.dataset.rangeMin;
      this.maxInput.value = radio.dataset.rangeMax;
    }

    const form = this.closest('form');
    if (form) form.dispatchEvent(new Event('input'));
  }
}
customElements.define('price-range-checkboxes', PriceRangeCheckboxes);

class LayoutSwitcher extends HTMLElement {
	constructor() {
    super();

    this.cookieName = 'beyours:collection-layout';

    this.initLayoutMode();
    this.querySelectorAll('.list-view__item').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
	}
	
  onButtonClick(event) {
    const target = event.target ? event.target : event;
    this.changeLayoutMode(target, target.dataset.layoutMode);
  }

  initLayoutMode() {
    if (isStorageSupported('local')) {
      const layoutMode = window.localStorage.getItem(this.cookieName);

      if (layoutMode !== null) {
        const target = this.querySelector(`.list-view__item[data-layout-mode="${layoutMode}"]`);

        if (target) {
          this.changeLayoutMode(target, layoutMode);
        }
      }
    }
  }

  changeLayoutMode(target, layoutMode) {
    const productGrid = document.getElementById('product-grid');

    if (productGrid.classList.contains('collection--empty')) {
      return;
    }

    const removedClass = ['list', 'grid', 'grid--1-col', 'grid--2-col', 'grid--3-col-tablet', 'grid--2-col-desktop', 'grid--3-col-desktop', 'grid--4-col-desktop'];
    removedClass.forEach((removed) => {
      productGrid.classList.remove(removed);
    });

    let addedClass = [];
    switch (layoutMode) {
      case 'list':
        addedClass = ['grid', 'grid--1-col', 'grid--2-col-desktop', 'list'];
        break;

      case 'grid-2':
        addedClass = ['grid', 'grid--2-col'];
        break;

      case 'grid-3':
        addedClass = ['grid', 'grid--2-col', 'grid--3-col-tablet', 'grid--3-col-desktop'];
        break;

      case 'grid-4':
        addedClass = ['grid', 'grid--2-col', 'grid--3-col-tablet', 'grid--4-col-desktop'];
        break;
    }
    addedClass.forEach((added) => {
      productGrid.classList.add(added);
    });

    this.querySelectorAll('.list-view__item').forEach(
      (button) => button.classList.remove('list-view__item--active')
    );

    target.classList.add('list-view__item--active');

    if (isStorageSupported('local')) {
      window.localStorage.setItem(this.cookieName, layoutMode);
    }
  }
}
customElements.define('layout-switcher', LayoutSwitcher);

class StickyFacetFilters extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.parentNode.offsetTop) {
      window.requestAnimationFrame(this.reveal.bind(this));
    } else {
      window.requestAnimationFrame(this.reset.bind(this));
    }
  }

  reveal() {
    this.classList.add('shopify-section-filters-sticky');
  }

  reset() {
    this.classList.remove('shopify-section-filters-sticky');
  }
}
customElements.define('sticky-facet-filters', StickyFacetFilters);

class ShowMoreButton extends HTMLElement {
  constructor() {
    super();

    const attributes = {
      expanded: 'aria-expanded'
    };

    const button = this.querySelector('.button-show-more');
    button.addEventListener('click', () => {
      const filter = this.closest('.js-filter');
      filter.setAttribute(
        attributes.expanded,
        (filter.getAttribute(attributes.expanded) === 'false').toString()
      );

      this.querySelectorAll('.visually-hidden').forEach(element => element.classList.toggle('hidden'));
    });
  }
}
customElements.define('show-more-button', ShowMoreButton);
